import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    headerContent:{
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    iconContent:{
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    otherEventsContent : {
        position: "absolute",
        left: 0,
        right:0,
        bottom: 0,
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        flex: 1
    },
    headerButton: {
    },
    activeEventsContainer: {
    },
    sectionTitle: {
    },
    activeEventCard: {
        overflow: "hidden",
        height: 230
    },
    activeEventCardContent: {
        alignSelf: "flex-start",
        flexDirection: "row",
        alignItems: "center"
    },
    activeEventCompanyLogo: {
    },
    activeEventTitle: {
        maxWidth: "80%",
        textAlign: "left"
    },
    activeEventDetails: {
        flexDirection: "row"
    },
    activeEventDetailText: {
    },
    joinButton: {
    },
    incomingEventCard: {
        flex: 1
    },
    incomingEventTitle: {
    },
    incomingEventDetails: {
        flexDirection: "row"
    },
    incomingEventDetailText: {
    },
    otherEventsContainer: {
    },
    otherEventCard: {
        flex: 1
    },
    otherEventImage: {
        width: "100%",
        height: 200
    },
    otherEventCompanyInfo: {
        flexDirection: "row",
        alignItems: "center",
        flex: 1
    },
    otherEventCompanyLogo: {
        width: 50,
        height: 50
    },
    otherEventCompanyTexts: {
        alignItems: "flex-start",
        flex: 1
    },
    otherEventCompanyTitle: {
    },
    otherEventJoinTag: {
    },
    bottomSheetHeader: {
        alignItems: "center"
    },
    bottomSheet: {
    },
    filterOptionButton: {
    },
    filterOptionIcon: {
    },
    loadingContainer: {
        alignItems: "center",
        justifyContent: "center"
    }
});
export default stylesheet;
